<template>
  <div id="ComplianceMessagingReport" style="text-transform: capitalize">
    <div data-html2canvas-ignore="true" v-show="loader">
      <Loader />
    </div>
    <div class="datepickerwrap card revampCard" style="flex-direction: row">
      <div class="leftcontent wrapitem">
        <div class="datebox">
          <datepicker
            placeholder="From"
            @input="changeCustomDate"
            v-model="date.startDate"
          />
        </div>
        <div class="datebox customSelect" style="min-width: 17%">
          <select
            v-model="selected_website"
            @click="websiteChanged"
            class="form-control text-uppercase"
          >
            <optgroup label="Retail">
              <!-- <option value="all">All</option> -->
              <option value="https://www.amazon.com">Amazon US</option>
              <option value="https://www.amazon.fr">Amazon France</option>
              <option value="https://www.amazon.co.it">Amazon Italy</option>
              <option value="https://www.amazon.es">Amazon Spain</option>
              <option value="https://www.amazon.co.uk">Amazon UK</option>
              <option value="https://www.amazon.de">Amazon Germany</option>
              <option value="https://www.bestbuy.com">Best Buy US</option>
              <option value="https://www.newegg.com">Newegg</option>
              <option value="https://www.microcenter.com">Microcenter</option>
              <option value="https://www.costco.com">Costco US</option>
              <option value="https://www.currys.co.uk">Curry's UK</option>
              <option value="https://www.harveynorman.com.au">Harvey Norman AU</option>
              <option value="https://global.jd.com">JD GC</option>
              <option value="https://www.mediamarkt.de">MediaMarkt DE</option>
              <option value="https://www.walmart.com">Walmart US</option>
            </optgroup>
            <optgroup label="Consumer OEM">
              <option value="https://br-store.acer.com">Acer Brazil</option>
              <option value="https://store.acer.com/en-us">Acer US</option>
              <option value="https://www.asus.com/fr">ASUS France</option>
              <option value="https://store.asus.com/us">ASUS US</option>
              <option value="https://www.asus.com">ASUS WW</option>
              <option value="https://www.dell.com/en-au">Dell Australia</option>
              <option value="https://www.dell.com/ja-jp">Dell Japan</option>
              <option value="https://www.dell.com/en-us">Dell US</option>
              <option value="https://www.dell.com/en-uk">Dell UK</option>
              <option value="https://fmv.fccl.fujitsu.com">Fujitsu Japan</option>
              <option value="https://store.hp.com/FranceStore">HP France</option>
              <option value="https://www8.hp.com/jp">HP Japan</option>
              <option value="https://store.hp.com/mx-es">HP Mexico</option>
              <option value="https://store.hp.com/UKStore">HP UK</option>
              <option value="https://store.hp.com/us">HP US</option>
              <option value="https://www.lenovo.com/au">Lenovo Australia</option>
              <option value="https://s.lenovo.com.cn">Lenovo China</option>
              <option value="https://www.lenovo.com/fr">Lenovo France</option>
              <option value="https://www.lenovo.com/de">Lenovo Germany</option>
              <option value="https://www.lenovo.com/gb">Lenovo UK</option>
              <option value="https://www.lenovo.com/us">Lenovo US</option>
              <option value="https://www.nec-lavie.jp">NEC Japan</option>
            </optgroup>
            <optgroup label="Commercial OEM">
              <option value="https://www.hpstore.cn#commercial">
                Commercial HP China
              </option>
              <option value="https://store.hp.com/FranceStore#commercial">
                Commercial HP France
              </option>
              <option value="https://store.hp.com/GermanyStore#commercial">
                Commercial HP Germany
              </option>
              <option value="https://www8.hp.com/jp#commercial">
                Commercial HP Japan
              </option>
              <option value="https://store.hp.com/UKStore#commercial">
                Commercial HP UK
              </option>
              <option value="https://store.hp.com/us#commercial">Commercial HP US</option>
              <option value="https://b2b.lenovo.com.cn#commercial">
                Commercial Lenovo China
              </option>
              <option value="https://www.lenovo.com/fr#commercial">
                Commercial Lenovo France
              </option>
              <option value="https://www.lenovo.com/de#commercial">
                Commercial Lenovo Germany
              </option>
              <option value="https://www.lenovo.com/jp#commercial">
                Commercial Lenovo Japan
              </option>
              <option value="https://www.lenovo.com/gb#commercial">
                Commercial Lenovo UK
              </option>
              <option value="https://www.lenovo.com/us#commercial">
                Commercial Lenovo US
              </option>
            </optgroup>
            <optgroup label="Commercial Reseller">
              <option value="https://www.bechtle.com">Bechtle</option>
              <option value="https://www.cdw.com">CDW</option>
              <option value="https://www.inmac-wstore.com">Inmac</option>
              <option value="https://www.insight.com/en-US">Insight</option>
              <option value="https://www.connection.com">PC Connection</option>
              <option value="https://www.shi.com">SHI</option>
              <option value="https://www.technoworld.com">TechnoWorld</option>
            </optgroup>
          </select>
        </div>
        <div class="datebox customSelect">
          <select v-model="device" @change="refresh" class="form-control text-uppercase">
            <option v-if="!cpuGpuSites.includes(selected_website)" value="laptop">
              Laptop
            </option>
            <option v-if="!cpuGpuSites.includes(selected_website)" value="desktop">
              Desktop
            </option>
            <option v-if="cpuGpuSites.includes(selected_website)" value="gpu">GPU</option>
            <option v-if="cpuGpuSites.includes(selected_website)" value="cpu">CPU</option>
          </select>
        </div>
        <div class="datebox">
          <button @click="refresh" class="btn primarycolor" type="button">Submit</button>
        </div>
      </div>
      <div class="righcontent wrapitem">
        <div class="datebox" style="float: right">
          <button
            @click="backToSov"
            style="width: max-content; float: right"
            class="navigationButton"
            type="button"
          >
            <img src="Icons_SVG/Arrow_Left.svg" height="14" class="backIcon" />
            <span> Back</span>
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="">
        <div v-if="!(device == 'cpu' || device == 'gpu')">
          <div class="card revampCard p-2" v-if="activeComChart">
            <highcharts :options="comChart" v-if="activeComChart"></highcharts>
          </div>
        </div>
        <div class="card revampCard p-2">
          <div class="space-between-header">
            <h4 class="graphHeading">
              AMD {{ deviceMapper[device] }} Compliance: {{ selectedWebComplianceScore }}
            </h4>

            <div style="display: flex">
              <div class="checkbox-btn">
                <input type="checkbox" @change="showHeroChange" v-model="isHero" />
                Hero SKUs
              </div>
              <span v-if="showSegment" style="display: flex">
                <span v-if="segData.segment_check" class="green-btn">
                  Segmentation Filter
                </span>
                <span v-else class="pink-btn"> Segmentation Filter </span>
              </span>
              <button @click="exportComp" class="ui button exportButton">Export</button>
            </div>
          </div>
          <table
            id="amdglobal-compliance-messaging-reportTable"
            v-if="rows_details.length"
            class="table"
            style="transform: rotateX(180deg)"
          >
            <thead class="thead-normal">
              <tr>
                <th>SKU</th>
                <th v-for="d in columns_details" :key="d.field">{{ d.label }}</th>
                <th v-for="d in getMsgHeader()" :key="d" style="min-width: 150px">
                  {{ d }}
                </th>
                <th v-for="d in columnsAudit" :key="d.field">
                  {{ d.label }}
                </th>
              </tr>
              <tr>
                <th></th>
                <th v-for="d in columns_details" :key="d.field"></th>
                <th v-for="d in getMsgHeader()" :key="d"></th>
                <th
                  v-for="d in columnsAudit"
                  :key="d.field"
                  :style="[d.field == 'message' && { 'min-width': '150px' }]"
                >
                  <span
                    v-if="d.field == 'compliance_score'"
                    class="d-flex justify-content-center"
                  >
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.comScore"
                      >?</b-btn
                    >
                  </span>
                  <span
                    v-if="d.field == 'position_score'"
                    class="d-flex justify-content-center"
                  >
                    <b-btn
                      class="hint"
                      v-b-tooltip.hover
                      title="(100 - Category Position) 
                        if Category Position < 100,
                        0 if Category Position > 100"
                      >?</b-btn
                    >
                  </span>
                  <span
                    v-if="d.field == 'sku_score'"
                    class="d-flex justify-content-center"
                  >
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.sku"></b-btn>
                  </span>
                  <span
                    v-if="d.field == 'rating_score'"
                    class="d-flex justify-content-center"
                  >
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.ratingScore"
                      >?</b-btn
                    >
                  </span>
                  <span
                    v-if="d.field == 'category_position'"
                    class="d-flex justify-content-center"
                  >
                    <b-btn
                      class="hint"
                      v-b-tooltip.hover
                      title="Position In Category Page"
                      >?</b-btn
                    >
                  </span>
                  <span
                    v-if="d.field == 'category_13_position'"
                    class="d-flex justify-content-center"
                  >
                    <b-btn
                      class="hint"
                      v-b-tooltip.hover
                      title="1: If System in page 1 of results
                        2: if System in page 2-3 of results
                        3: if System not in pages 1-3 "
                      >?</b-btn
                    >
                  </span>
                  <span
                    v-if="d.field == 'search_position'"
                    class="d-flex justify-content-center"
                  >
                    <b-btn
                      class="hint"
                      v-b-tooltip.hover
                      title="Position in on-site search"
                      >?</b-btn
                    >
                  </span>
                  <span
                    v-if="d.field == 'search_13_position'"
                    class="d-flex justify-content-center"
                  >
                    <b-btn
                      class="hint"
                      v-b-tooltip.hover
                      title="1: If System in page 1 of search results
                        2: if System in page 2-3 of search results
                        3: if System not in pages 1-3 "
                      >?</b-btn
                    >
                  </span>
                  <span v-if="d.field == 'logo'" class="d-flex justify-content-center">
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.plogo">?</b-btn>
                  </span>
                  <span
                    v-if="d.field == 'image_count'"
                    class="d-flex justify-content-center"
                  >
                    <b-btn
                      class="hint"
                      v-b-tooltip.hover
                      title="1: 3 or more product images
                        2: 2 more product images
                        3: 0 or 1 product images"
                      >?</b-btn
                    >
                  </span>
                  <span
                    v-if="d.field == 'product_nomenclature'"
                    class="d-flex justify-content-center"
                  >
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.psnomen"
                      >?</b-btn
                    >
                  </span>
                  <span
                    v-if="d.field == 'hero_nomenclature'"
                    class="d-flex justify-content-center"
                  >
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.hbnomen"
                      >?</b-btn
                    >
                  </span>
                  <span
                    v-if="d.field == 'nomenclature'"
                    class="d-flex justify-content-center"
                  >
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.nomen">?</b-btn>
                  </span>
                  <span
                    v-if="d.field == 'other_nomenclature'"
                    class="d-flex justify-content-center"
                  >
                    <b-btn class="hint" v-b-tooltip.hover :title="tooltip.onomen"
                      >?</b-btn
                    >
                  </span>
                </th>
              </tr>
            </thead>
            <tfoot style="display: table-row-group">
              <tr>
                <th><span>SKU</span></th>
                <th v-for="d in columns_details" :key="d.field">{{ d.label }}</th>
                <th v-for="d in getMsgHeader()" :key="d">{{ d }}</th>
                <th v-for="d in columnsAudit" :key="d.field">{{ d.label }}</th>
              </tr>
            </tfoot>
            <tbody class="tbody-normal">
              <tr
                v-for="(r, i) in rows_details"
                :key="i"
                v-if="r['processor'] == 'amd' || device == 'gpu'"
              >
                <td>
                  <span>{{ r.audit["sku"] }}</span>
                </td>
                <td
                  v-for="d in columns_details"
                  :key="d.field"
                  :class="{ minWid: d.field == 'product_name' }"
                >
                  <span v-if="d.field == 'product_name'"
                    ><a target="_blank" :href="r['link']">{{ r[d.field] }}</a></span
                  >
                  <span
                    v-else-if="d.field == 'processor'"
                    style="text-transform: uppercase"
                    >{{ r[d.field] }}</span
                  >
                  <span v-else>{{ r[d.field] }}</span>
                </td>
                <td
                  :class="{ minWid: d.val.length > 10 }"
                  v-for="d in getMsgCols(r.audit.messaging)"
                >
                  <div style="font-weight: bolder" v-if="d.heading">{{ d.heading }}</div>
                  <span>{{ d.val }}</span>
                </td>
                <td
                  :class="{
                    minWid:
                      d.field.includes('text') || d.field.includes('messaging_match'),
                  }"
                  v-for="d in columnsAudit"
                  :key="d.field"
                >
                  <span>{{ formatTradeMark(i, d.field) }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <div style="height: 80px"></div> -->
      </div>
    </div>
  </div>
</template>
<script>
"";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Loader from "./Components/Loader.vue";

export default {
  name: "ComplianceMessagingReport",
  components: { Datepicker, Loader },
  data: function () {
    return {
      selected_website: localStorage.selected_SOVWebsite,
      device: localStorage.selected_category,
      date: {
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
      },
      columns_details: [
        { label: "Name", field: "product_name", sortable: false },
        { label: "Processor Type", field: "processor_type", sortable: false },
        { label: "Processor Model", field: "processor_model", sortable: false },
        { label: "Brand", field: "brand", sortable: false },
        { label: "Ratings", field: "ratings" },
      ],
      rows: [],
      rows_details: [],
      oem_websites: [
        "https://www.amazon.fr",
        "https://www.amazon.co.it",
        "https://www.amazon.es",
        "https://www.amazon.co.uk",
        "https://www.amazon.de",
        "https://www.technoworld.com",
        "https://www.inmac-wstore.com",
        "https://www.asus.com",
        "https://www.bechtle.com",
        "https://www.connection.com",
        "https://www.shi.com",
        "https://www8.hp.com/jp#commercial",
        "https://www.lenovo.com/jp#commercial",
        "https://b2b.lenovo.com.cn#commercial",
        "https://www.hpstore.cn#commercial",
        "https://www.nec-lavie.jp",
        "https://fmv.fccl.fujitsu.com",
        "https://www.dell.com/ja-jp",
        "https://www.dell.com/en-au",
        "https://www.lenovo.com/au",
        "https://br-store.acer.com",
        "https://s.lenovo.com.cn",
        "https://store.hp.com/FranceStore",
        "https://store.hp.com/mx-es",
        "https://www.lenovo.com/fr",
        "https://www.insight.com/en-US",
        "https://store.hp.com/FranceStore#commercial",
        "https://www.lenovo.com/fr#commercial",
        "https://www.cdw.com",
        "https://www.lenovo.com/gb#commercial",
        "https://store.hp.com/UKStore#commercial",
        "https://www.lenovo.com/de#commercial",
        "https://store.hp.com/GermanyStore#commercial",
        "https://www8.hp.com/jp",
        "https://store.hp.com/us#commercial",
        "https://www.lenovo.com/us#commercial",
        "https://store.hp.com/UKStore",
        "https://store.hp.com/us",
        "https://www.asus.com/fr",
        "https://store.asus.com/us",
        "https://www.dell.com/en-us",
        "https://www.dell.com/en-uk",
        "https://fmv.fccl.fujitsu.com",
        "https://store.acer.com/en-us",
        "https://www.lenovo.com/us",
        "https://www.lenovo.com/gb",
        "https://www.lenovo.com/de",
      ],
      cpuGpuSites: [
        "https://www.amazon.com",
        "https://www.microcenter.com",
        "https://www.newegg.com",
        "https://www.bestbuy.com",
      ],
      comChart: {},
      activeComChart: false,
      page: 1,
      showAuditModal: false,
      brand_data: {},
      columnsAudit: [],

      rowsAudit: [],
      isHero: false,
      rows_details_full: [],
      loader: false,
      selectedWebComplianceScore: "",
      deviceMapper: {
        laptop: "PC",
        desktop: "Desktop",
      },
      tooltip: {
        comScore: "",
        sku: "",
        ratingScore: "",
        plogo: "",
        nomen: "",
        msg: "",
      },
      segData: {},
      showSegment: false,
      isOEM: false,
      commercialSites: [
        "https://www.amazon.fr",
        "https://www.amazon.co.it",
        "https://www.amazon.es",
        "https://www.amazon.co.uk",
        "https://www.amazon.de",
        "https://www.technoworld.com",
        "https://www.inmac-wstore.com",
        "https://www.bechtle.com",
        "https://www.connection.com",
        "https://www.shi.com",
        "https://www8.hp.com/jp#commercial",
        "https://www.lenovo.com/jp#commercial",
        "https://b2b.lenovo.com.cn#commercial",
        "https://www.hpstore.cn#commercial",
        "https://www.insight.com/en-US",
        "https://store.hp.com/FranceStore#commercial",
        "https://www.lenovo.com/fr#commercial",
        "https://www.cdw.com",
        "https://www.lenovo.com/gb#commercial",
        "https://store.hp.com/UKStore#commercial",
        "https://www.lenovo.com/us#commercial",
        "https://www.lenovo.com/de#commercial",
        "https://store.hp.com/GermanyStore#commercial",
        "https://store.hp.com/us#commercial",
      ],
      retailSites: [
        "https://www.amazon.com",
        "https://www.amazon.fr",
        "https://www.amazon.co.uk",
        "https://www.amazon.de",
        "https://www.amazon.co.it",
        "https://www.amazon.es",
        "https://www.amazon.co.uk",
        "https://www.amazon.de",
        "https://www.bestbuy.com",
        "https://www.newegg.com",
        "https://www.microcenter.com",
        "https://www.costco.com",
        "https://www.currys.co.uk",
        "https://www.harveynorman.com.au",
        "https://global.jd.com",
        "https://www.mediamarkt.de",
        "https://www.walmart.com",
      ],
      msgCols: [],
    };
  },
  mounted() {
    this.initCols();
    if (this.oem_websites.includes(this.selected_website)) this.getSegment();
    this.website_details();
  },
  methods: {
    websiteChanged() {
      if (this.cpuGpuSites.includes(this.selected_website)) {
        this.device = "cpu";
      } else this.device = "laptop";
    },
    GPUCPUChecker() {
      if (this.device == "gpu") {
        this.columns_details.splice(1, 1, {
          label: "GPU Model",
          field: "gpu_model",
          sortable: false,
        });
        this.columns_details.splice(2, 1, {
          label: "GPU Type",
          field: "gpu_type",
          sortable: false,
        });
      } else {
        this.columns_details.splice(1, 1, {
          label: "Processor Type",
          field: "processor_type",
          sortable: false,
        });
        this.columns_details.splice(2, 1, {
          label: "Processor Model",
          field: "processor_model",
          sortable: false,
        });
      }
    },
    getMsgHeader() {
      if (!this.rows_details[0].audit.hasOwnProperty("messaging")) {
        return [];
      } else {
        let arr = [];
        for (let [idx, ds] of this.rows_details[0].audit.messaging.entries()) {
          arr.push("Messaging Section " + ds.index + " Score");
          arr.push("Messaging Section " + ds.index + " on Site");
          arr.push("Messaging Section " + ds.index + " Comment");
        }
        return arr;
      }
    },
    getMsgCols(msging) {
      if (msging == undefined) {
        return [];
      }
      let arr = [];
      for (let [idx, ds] of msging.entries()) {
        let obj1 = { heading: "", val: ds.score };
        arr.push(obj1);
        if (ds.message == "") ds.message = "N/A";
        if (ds.heading) ds.heading = this.formatTradeMarkString(ds.heading);
        let obj2 = { heading: ds.heading, val: this.formatTradeMarkString(ds.message) };
        arr.push(obj2);

        if (ds.comment == "") ds.comment = "N/A";
        let obj3 = { heading: "", val: this.formatTradeMarkString(ds.comment) };
        arr.push(obj3);
      }
      return arr;
    },
    formatTradeMarkString(s) {
      return s.replace(/#/g, "™").replace(/\$/g, "® ");
    },
    formatTradeMark(i, key) {
      if (
        typeof this.rows_details[i]["audit"][key] == "string" &&
        this.rows_details[i]["audit"][key].length
      ) {
        this.rows_details[i]["audit"][key] = this.formatTradeMarkString(
          this.rows_details[i]["audit"][key]
        );
        return this.rows_details[i]["audit"][key];
      }
      return this.rows_details[i]["audit"][key];
    },
    exportComp() {
      let self = this;
      let payload = {
        header: [
          { key: "sku", label: "SKU" },
          { key: "link", label: "Link" },
        ],
        data: [],
        file_type: "compliance_messaging",
      };
      for (let [idx, ds] of self.columns_details.entries()) {
        payload.header.push({ key: ds.field, label: ds.label });
      }
      for (let [idx, ds] of this.rows_details[0].audit.messaging.entries()) {
        payload.header.push({
          key: "messaging_" + "score_" + ds.index,
          label: "Messaging Section " + ds.index + " Score",
        });
        payload.header.push({
          key: "messaging_" + "message_" + ds.index,
          label: "Messaging Section " + ds.index + " on Site",
        });
        payload.header.push({
          key: "messaging_" + "comment_" + ds.index,
          label: "Messaging Section " + ds.index + " Comment",
        });
      }

      for (let [idx, ds] of self.columnsAudit.entries()) {
        payload.header.push({ key: ds.field, label: ds.label });
      }
      for (let [idx, ds] of self.rows_details_full.entries()) {
        if (ds.processor == "amd") {
          for (let [indx, dataset] of ds.audit.messaging.entries()) {
            ds["messaging_" + "score_" + dataset.index] = dataset.score;
            ds.audit["messaging_" + "score_" + dataset.index] = dataset.score;

            if (dataset.heading) {
              ds["messaging_" + "message_" + dataset.index] =
                this.formatTradeMarkString(dataset.heading) +
                ": " +
                this.formatTradeMarkString(dataset.message);
              ds.audit["messaging_" + "message_" + dataset.index] =
                this.formatTradeMarkString(dataset.heading) +
                ": " +
                this.formatTradeMarkString(dataset.message);
            } else {
              ds["messaging_" + "message_" + dataset.index] = this.formatTradeMarkString(
                dataset.message
              );
              ds.audit[
                "messaging_" + "message_" + dataset.index
              ] = this.formatTradeMarkString(dataset.message);
            }
            ds["messaging_" + "comment_" + dataset.index] = this.formatTradeMarkString(
              dataset.comment
            );
            ds.audit[
              "messaging_" + "comment_" + dataset.index
            ] = this.formatTradeMarkString(dataset.comment);
          }
          payload.data.push(ds);
        }
      }

      const url = "/api/websites/export";
      self.$http.post(url, payload).then(
        (response) => {
          window.location = response.body.file;
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    getSegment() {
      let self = this;
      self.loader = true;
      let payload = {
        website: this.selected_website,
        item_category: self.device,
      };
      const url = "/api/websites/website_check";
      self.$http.post(url, payload).then(
        (response) => {
          self.segData = response.body;
          self.loader = false;
        },
        (err) => {
          self.loader = false;
          console.log("err");
        }
      );
    },
    initCols() {
      let self = this;
      this.GPUCPUChecker();
      if (this.oem_websites.includes(this.selected_website)) {
        this.isOEM = true;
        this.tooltip = {
          ratingScore: "(Rating/5)*100",
          plogo: "1: Correct AMD Badges \n 2: Incorrect AMD Badges \n 3: No AMD Badges",
          psnomen:
            "1: Complete & Correct AMD Nomenclature \n 2: Incomplete AMD Nomenclature \n 3: Incorrect AMD Nomenclature \n N/A: Missing AMD Nomenclature",
          hbnomen:
            "1: Complete & Correct AMD Nomenclature \n 2: Incomplete AMD Nomenclature \n 3: Incorrect AMD Nomenclature \n N/A: Missing AMD Nomenclature",
          nomen:
            "Product Specs Nomenclature, if Hero Banner Nomenclature = N/A \n (Product Specs Nomenclature + Hero Banner Nomenclature) /2 \n *Other Nomenclature Text is not counted in Overall Nomenclature Score",
          onomen:
            "1: Complete & Correct AMD Nomenclature \n 2: Incomplete AMD Nomenclature \n 3: Incorrect AMD Nomenclature \n N/A: Missing AMD Nomenclature",
          msg:
            "1: Correct AMD Messaging \n 2: Incorrect AMD Messaging \n 3: No AMD Messaging",
        };
        this.showSegment = true;
        this.tooltip.comScore = "((6-(Nomenclature + Message))*100/4)";
        this.tooltip.sku = "(Compliance Score  + Rating Score)/2";
        // let oemList1 = ["https://www.lenovo.com/us","https://www.lenovo.com/gb","https://www.lenovo.com/de","https://store.hp.com/UKStore","https://store.hp.com/us","https://www.dell.com/en-us","https://store.asus.com/us"]
        let customSites = [
          "https://www8.hp.com/jp",
          "https://br-store.acer.com",
          "https://www.lenovo.com/gb#commercial",
          "https://s.lenovo.com.cn",
        ];
        if (customSites.includes(self.selected_website)) {
          this.tooltip.comScore = "((9-(AMD Badges + Nomenclature + Message))*100/6)";
          if (self.selected_website === "https://www.lenovo.com/gb#commercial") {
            this.tooltip.comScore = "((6-(Nomenclature + Message))*100/4)";
          }
        }
        let cScore3Sites = ["https://www.bechtle.com"];
        if (cScore3Sites.includes(self.selected_website)) {
          this.tooltip.comScore = "((3-NOMENCLATURE)/2)x 100";
        }
        this.columnsAudit = [
          { label: "Correct Text", field: "messaging_match", sortable: false },
          { label: "Overall Messaging Score", field: "message", sortable: false },
          // {label: 'Correct Product Specs Text', field: 'product_text_match',sortable: false},
          // {label: 'Hero Banner Score', field: 'hero_nomenclature',sortable: false},
          // {label: 'Hero Banner Text On Site', field: 'hero_text',sortable: false},
          // {label: 'Correct Hero Banner Text', field: 'hero_text_match',sortable: false},
          // {label: 'Other Score', field: 'other_nomenclature',sortable: false},
          // {label: 'Other Text On Site', field: 'other_text',sortable: false},
          // {label: 'Correct Other Text', field: 'other_text_match',sortable: false},
          // {label: 'Nomenclature', field: 'nomenclature',sortable: false},
          { label: "Compliance Score", field: "compliance_score", sortable: false },
        ];
        if (self.commercialSites.includes(self.selected_website)) {
          this.tooltip.nomen =
            "1: Correct AMD Nomenclature \n 2: Incorrect AMD Nomenclature \n 3: No AMD Nomenclature";
          this.columnsAudit = [
            { label: "Correct Text", field: "messaging_match", sortable: false },
            { label: "Overall Messaging Score", field: "message", sortable: false },
            { label: "Compliance Score", field: "compliance_score", sortable: false },
          ];
        }
      } else {
        this.isOEM = false;
        this.tooltip = {
          ratingScore: "(Rating/5)*100",
          plogo: "1: Correct AMD Badges \n 2: Incorrect AMD Badges \n 3: No AMD Badges",
          nomen:
            "1: Correct AMD Nomenclature \n 2: Incorrect AMD Nomenclature \n 3: No AMD Nomenclature",
          msg:
            "1: Correct AMD Messaging \n 2: Incorrect AMD Messaging \n 3: No AMD Messaging",
        };
        this.showSegment = false;
        this.tooltip.comScore =
          "((12-(AMD Badges + Product Images + Nomenclature + Message))/8)*100";
        this.tooltip.sku = "(Compliance Score + Position Score + Rating Score)/3";
        this.columnsAudit = [
          { label: "Rating Score", field: "rating_score", sortable: false },
          { label: "AMD Badges", field: "logo", sortable: false },
          { label: "Product Images", field: "image_count", sortable: false },
          { label: "Nomenclature", field: "nomenclature", sortable: false },
          { label: "Message", field: "message", sortable: false },
          { label: "Compliance Score", field: "compliance_score", sortable: false },
          { label: "Category Position", field: "category_position", sortable: false },
          {
            label: "Category page position (1-3)",
            field: "category_13_position",
            sortable: false,
          },
          // {label: 'Search Position', field: 'search_position',sortable: false},
          // {label: 'Search (1-3) Position', field: 'search_13_position',sortable: false},
          { label: "Position Score", field: "position_score", sortable: false },
          { label: "SKU Score", field: "sku_score", sortable: false },
        ];
      }
      if (this.retailSites.includes(this.selected_website)) {
        this.tooltip.comScore =
          "((12-(SUM(AMD Badges + Product Images + Nomenclature + Message)))/8)*100";
      }
    },
    backToSov() {
      window.location = "#/compliance-detail";
    },
    showHeroChange() {
      let self = this;
      $("#amdglobal-compliance-messaging-reportTable").DataTable().destroy();
      this.rows_details = [];
      for (let [idx, dataset] of this.rows_details_full.entries()) {
        if (self.isHero) {
          if (dataset.is_hero) {
            this.rows_details.push(dataset);
          }
        } else this.rows_details.push(dataset);
      }
      this.$nextTick(function () {
        self.initDt2();
      });
    },

    openAuditModal(r) {
      let self = this;
      self.rowsAudit = [];
      self.showAuditModal = true;
      self.rowsAudit.push(r.audit);
    },

    format(v) {
      return this.$options.filters.format(v);
    },
    refresh() {
      $("#amdglobal-compliance-messaging-reportTable").DataTable().destroy();
      this.initCols();
      if (this.oem_websites.includes(this.selected_website)) this.getSegment();
      localStorage.selected_SOVWebsite = this.selected_website;
      localStorage.selected_category = this.device;
      this.website_details();
    },
    drawComChart() {
      let self = this;
      let categories = [];
      let data1 = [];
      let arr = [];
      let highlight_color = "";
      let min_com = 0;
      let com_data = [];

      for (const [key, value] of Object.entries(self.brand_data)) {
        com_data.push({ website: key, score: value });
      }

      let sortedArr = com_data.sort((a, b) => a.score - b.score);
      for (let [idx, dataset] of sortedArr.entries()) {
        if (dataset.website == "hp") dataset.website = "HP";
        if (sortedArr.length == 1) {
          categories.push(dataset.website);
        } else {
          if (idx == 0)
            categories.push(dataset.website + "<br/> <b>(Least Compliant)</b>");
          else if (idx == sortedArr.length - 1)
            categories.push(dataset.website + "<br/> <b>(Most Compliant)</b>");
          else categories.push(dataset.website);
        }
        data1.push(dataset.score);
      }

      self.comChart = {
        chart: {
          type: "column",
          height: 230,
          marginTop: 45,
        },
        title: {
          text: " ",
        },
        subtitle: {
          text: "",
        },
        xAxis: {
          categories: categories,
          title: {
            text: "OEM",
          },
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true,
              style: { fontWeight: 0 },
              formatter: function () {
                return this.point.y;
              },
            },
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "Compliance Score",
          },
        },
        tooltip: {
          shared: true,
          enabled: false,
        },

        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "",
            data: data1,
            // color: '#8a87e8',
            pointWidth: 60,
            dataSorting: {
              enabled: true,
            },
          },
        ],
      };
      setTimeout(function () {
        self.activeComChart = true;
      }, 0);
    },
    website_details() {
      let self = this;
      self.loader = true;
      self.rows_details = [];
      self.rows_details_full = [];
      let url = "/api/websites/details";
      if (self.isOEM) {
        url = "/api/websites/oem_details";
        if (self.commercialSites.includes(self.selected_website))
          url = "/api/websites/commercial_details";
      }
      if (this.device == "gpu" || this.device == "cpu")
        url = "/api/websites/cpu_gpu_details";
      self.activeComChart = false;
      let payload = { website: this.selected_website, timestamp: this.date.startDate };
      payload["item_category"] = self.device;
      this.$http.post(url, payload).then(
        (response) => {
          self.loader = false;
          self.brand_data = response.body.brand_data;
          self.selectedWebComplianceScore = response.body.final_compliance_score;
          if (!this.isOEM) self.drawComChart();
          for (let [idx, ds] of response.body.data.entries()) {
            if (ds.brand.indexOf("hp") != -1) ds.brand = ds.brand.replace("hp", "HP");
            if (this.device != "gpu")
              if (ds.processor_type.indexOf("amd") != -1)
                ds.processor_type = ds.processor_type.replace("amd", "AMD");
            self.rows_details.push(ds);
            self.rows_details_full.push(ds);
          }
          self.$nextTick(function () {
            self.initDt2();
          });
        },
        (err) => {
          self.loader = false;
          console.log(err);
          console.log("err");
        }
      );
    },

    changeCustomDate() {
      if (this.date.startDate)
        this.date.startDate = moment(this.date.startDate).format("YYYY-MM-DD");
    },
    initDt2() {
      let self = this;
      $("#amdglobal-compliance-messaging-reportTable").DataTable({
        language: {
          search: "",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
        // dom: '<"top">frt<"bottom"l>p<"clear">',
        pagingType: "full_numbers",
        // info: false,
        autoWidth: "false",
        initComplete: function () {
          this.api()
            .columns()
            .every(function () {
              var column = this;
              var select = $("<select><option value=''>All</option></select>")
                .appendTo($(column.footer()).empty())
                .on("change", function () {
                  var val = $.fn.dataTable.util.escapeRegex($(this).val());
                  column.search(val ? "^" + val + "$" : "", true, false).draw();
                });
              let arr = [];
              let sortedArr = [];
              column
                .data()
                .unique()
                .sort()
                .each(function (d, j) {
                  // console.log(d)
                  if (d == "N/A") d = "Na";
                  var myVal = $(d).text();

                  arr.push(myVal);
                });

              sortedArr = arr.sort((a, b) =>
                a.localeCompare(b, navigator.languages[0] || navigator.language, {
                  numeric: true,
                  ignorePunctuation: true,
                })
              );
              for (let [idx, ds] of sortedArr.entries()) {
                select.append("<option value='" + ds + "'>" + ds + "</option>");
              }
            });
        },
      });
      var search = require("../../public/Icons_SVG/Search.svg");
      $("#amdglobal-compliance-messaging-reportTable").wrap(
        "<div class='scrolledDataTable'></div>"
      );
      $("#amdglobal-compliance-messaging-reportTable_filter > label > input").attr(
        "placeholder",
        "Search"
      );
      $("#amdglobal-compliance-messaging-reportTable_filter > label").append(
        `<div><img src='${search}' /></div>`
      );
      $(
        "#amdglobal-compliance-messaging-reportTable_length > label > select"
      ).removeClass();
    },
  },
};
</script>

<style>
#amdglobal-compliance-messaging-reportTable_filter > label {
  display: flex;
  flex-direction: row;
  justify-content: end;
}
#amdglobal-compliance-messaging-reportTable_filter input {
  border-radius: 5px 0 0 5px !important;
  height: 35px;
  width: 220px;
  margin-bottom: 8px;
  outline: none;
  border-color: var(--primary_brand-60);
  border-right: none;
  padding: 10px 15px !important;
}
#amdglobal-compliance-messaging-reportTable_filter input:focus {
  border-color: var(--primary_brand) !important;
  outline: none !important;
  box-shadow: none !important;
}
#amdglobal-compliance-messaging-reportTable_filter input::placeholder {
  color: var(--primary_brand-40) !important;
}
#amdglobal-compliance-messaging-reportTable_filter input:-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}
#amdglobal-compliance-messaging-reportTable_filter input::-ms-input-placeholder {
  color: var(--primary_brand-40) !important;
}
#amdglobal-compliance-messaging-reportTable .page-item:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  box-shadow: none;
}
#amdglobal-compliance-messaging-reportTable_filter div {
  height: 35px;
  width: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  margin-left: -3px;
  background-color: var(--primary_brand);
}
#amdglobal-compliance-messaging-reportTable_filter img {
  height: 17px;
  filter: invert(97%) sepia(67%) saturate(13%) hue-rotate(242deg) brightness(103%)
    contrast(104%);
}

#amdglobal-compliance-messaging-reportTable_paginate {
  position: relative;
  top: 12px;
  z-index: 100;
  float: right;
  width: 50vw;
}
#amdglobal-compliance-messaging-reportTable_info {
  position: relative;
  top: 9px;
  left: 324px;
  z-index: 100;
  float: right;
  width: 50vw;
  font-size: 15px;
  /* font-weight: 600; */
  color: var(--primary_brand-80);
}
#amdglobal-compliance-messaging-reportTable_length {
  /* position: relative;
  top: 90px;
  left: 30px;
  z-index: 100;
  width: 50vw; */
}
#amdglobal-compliance-messaging-reportTable_length label {
  border-style: solid;
  border-width: thin;
  padding: 0 5px;
  height: 35px;
  border-radius: 5px;
  width: 170px;
  border-color: var(--primary_brand-40);
  display: flex;
  justify-content: space-between;
}
#amdglobal-compliance-messaging-reportTable_length h5 {
  width: fit-content;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-transform: none;
  padding: 10px 0 10px 10px;
  font-size: 15px;
  color: var(--primary_brand-80);
  margin: 0;
}
#amdglobal-compliance-messaging-reportTable_length select {
  width: 30px;
  height: 100%;
  text-align-last: center;
  border-radius: 5px;
  margin-right: 10px !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  appearance: none !important;
  border-color: var(--primary_brand-40) !important;
  background-color: #fff !important;
  color: var(--primary_brand-80);
}
#amdglobal-compliance-messaging-reportTable_paginate .page-link {
  border: none !important;
  background: none !important;
  color: var(--primary_brand-80) !important;
}
#amdglobal-compliance-messaging-reportTable_paginate ul.pagination li.active {
  border: 1px solid var(--primary_brand-40) !important;
  border-radius: 7px;
  box-shadow: none !important;
}
#amdglobal-compliance-messaging-reportTable {
  border-radius: 20px 20px 0 0;
}
#amdglobal-compliance-messaging-reportTable .thead-normal,
#amdglobal-compliance-messaging-reportTable .thead-normal tr:first-child,
#amdglobal-compliance-messaging-reportTable
  .thead-normal
  > tr:first-child
  > th:first-child {
  background-color: var(--background) !important;
  border-radius: 21px 0 0 0;
  border-left: 1px solid var(--base_color-20) !important;
}
#amdglobal-compliance-messaging-reportTable
  .thead-normal
  > tr:last-child
  > th:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}
#amdglobal-compliance-messaging-reportTable
  .thead-normal
  > tr:first-child
  > th:last-child {
  border-radius: 0 21px 0 0;
}
#amdglobal-compliance-messaging-reportTable .thead-normal > tr:first-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 5px 25px 0px 25px !important;
  color: rgb(78 78 78) !important;
  border-top: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
}
#amdglobal-compliance-messaging-reportTable .thead-normal > tr:last-child > th {
  font-size: 14px;
  letter-spacing: 0.1px;
  font-weight: 300 !important;
  text-align: center !important;
  padding: 0px 25px 5px 25px !important;
  color: rgb(78 78 78) !important;
  border-right: 1px solid var(--base_color-20) !important;
}
#amdglobal-compliance-messaging-reportTable .thead-normal > tr > th.sorting:before {
  font-size: 15px;
  bottom: 150%;
  color: var(--base_color-80);
}
#amdglobal-compliance-messaging-reportTable .thead-normal > tr > th.sorting:after {
  font-size: 15px;
  top: -30%;
  color: var(--base_color-80);
}
#amdglobal-compliance-messaging-reportTable th select {
  background-color: #fff !important;
  filter: brightness(99%);
  border: 1px solid #b1b1b1 !important;
  width: 100%;
  color: var(--primary_brand-60);
  font-size: 10px;
  border-radius: 7px;
  height: 33px;
}
#amdglobal-compliance-messaging-reportTable tfoot th {
  background-color: var(--background) !important;
  border-right: 1px solid var(--base_color-20) !important;
  border-bottom: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}
#amdglobal-compliance-messaging-reportTable tfoot th:first-child {
  background-color: var(--background) !important;
  border-left: 1px solid var(--base_color-20) !important;
  padding: 5px !important;
}
#amdglobal-compliance-messaging-reportTable tbody td {
  border-bottom: 1px solid var(--base_color-20) !important;
  border-right: 1px solid var(--base_color-20) !important;
  font-size: 13px !important;
  font-family: "Heebo", sans-serif !important;
}
#amdglobal-compliance-messaging-reportTable tbody td:first-child {
  border-left: 1px solid var(--base_color-20) !important;
}
#amdglobal-compliance-messaging-reportTable .even td {
  background: #fff !important;
}
#amdglobal-compliance-messaging-reportTable .odd td {
  background: #fff !important;
  /* filter: brightness(110%); */
}

/* #amdglobal-compliance-messaging-reportTable_wrapper .bottom {
  margin: -30px;
} */
#amdglobal-compliance-messaging-reportTable_wrapper > .row:last-child {
  margin-bottom: 15px;
}
#amdglobal-compliance-messaging-reportTable_wrapper .scrolledDataTable {
  border-left: none;
  border-right: none;
}
#amdglobal-compliance-messaging-reportTable_wrapper
  .scrolledDataTable::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(203, 203, 203, 0.3);
  border-radius: 10px;
  background: var(--base_color-10);
}

#amdglobal-compliance-messaging-reportTable_wrapper
  .scrolledDataTable::-webkit-scrollbar {
  height: 10px;
}

#amdglobal-compliance-messaging-reportTable_wrapper
  .scrolledDataTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background: var(--base_color-40);
}
#amdglobal-compliance-messaging-reportTable_wrapper
  .scrolledDataTable::-webkit-scrollbar-thumb:hover {
  background: var(--base_color-60);
}
</style>

<style scoped>
#ComplianceMessagingReport {
  font-family: "Poppins", sans-serif !important;
}
.revampCard {
  border-radius: 0.7rem !important;
  border: none !important;
}
.exportButton:hover {
  color: white !important;
  background: var(--primary_brand-80) !important;
  font-family: "poppins";
}

.customSelect :focus {
  background: var(--base_color-5);
  color: var(--primary_brand-60);
  border: 1px solid var(--primary_brand-60) !important;
  outline: none;
  box-shadow: none;
  font-weight: 600;
}
select {
  font-family: "Poppins", sans-serif;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 16px;
  /* border: 1.7px solid var(--primary_brand); */
}
button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
  /* border: 1.6px solid var(--base_color); */
}
.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}
.navigationButton:hover {
  background: var(--accent_color-80);
}

.form-control {
  border-radius: 5px !important;
  padding: 6px !important;
  font-size: 11px !important;
  height: 35px !important;
  border: 1px solid var(--base_color-40) !important;
}

.dataTables_filter input {
  border-radius: 10px;
}
.exportButton {
  margin-left: 6px;
  height: 35px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px;
  font-weight: 600;
  padding: 0px 25px;
  letter-spacing: 0.2px;
}
.purple-btn {
  margin-right: 6px;
  height: 35px;
  display: flex;
  padding: 7px;
  align-items: center;
  border: none;
  background-color: var(--primary_competitor-80);
  border-radius: 5px;
  color: #fff;
  font-weight: 600;
  padding: 0px 15px;
}
.green-btn {
  height: 35px;
  display: flex;
  padding: 7px;
  align-items: center;
  border: none;
  background-color: var(--green);
  border-radius: 5px;
  color: #fff;
  font-weight: 600;
  padding: 0px 15px;
}
.pink-btn {
  height: 35px;
  display: flex;
  padding: 7px;
  align-items: center;
  border: none;
  background-color: var(--pink);
  border-radius: 5px;
  color: #fff;
  font-weight: 600;
  padding: 0px 15px;
}
.checkbox-btn {
  margin-right: 6px;
  height: 35px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: none;
  background-color: var(--base_color-10);
  border-radius: 5px;
  color: #000;
  padding: 0px 10px;
}
.checkbox-btn span {
  padding: 0 5px;
}
.checkbox-btn input {
  margin: 4px;
  font-size: 11px;
  width: 15px;
  height: 15px;
  accent-color: #fff;
}
.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  margin-bottom: -20px !important ;
}
.backIcon {
  filter: brightness(0) saturate(100%) invert(98%) sepia(0%) saturate(206%)
    hue-rotate(268deg) brightness(116%) contrast(100%);
}
/* ---------- pre-revamp styles ----------- */
.custom-table {
  padding: 10px;
  margin: 10px;
}

.markitamd {
  background-color: #ffb9b9 !important;
}
.markitintel {
  background-color: #c7e0ff !important;
}
.markitsnap {
  background-color: #ffd0f5 !important;
}
.markitna {
  background-color: #edf2fb !important;
}
.markittek {
  background-color: #fff0ce !important;
}
.space-between-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 5px;
}
.space-between-header select {
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #4e4e4e;
  margin-bottom: 0;
  line-height: 31px;
}
.listing-custom {
  font-size: 18px;
  margin-bottom: 6px;
  text-align: center;
  width: 215px;
  background: #8a87e8;
}
.hint {
  cursor: pointer;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(78 78 78);
  border: 1px solid rgb(78 78 78);
  border-radius: 3px;
  padding: 3px;
  width: 17px;
  height: 17px;
  font-size: 12px;
}
.amd-legend {
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index: 999;
}
.amd-legend i {
  width: fit-content;
}
.amd-legend span {
  padding-left: 4px;
  font-size: 12px;
}
.legending {
  display: inline-block;
  margin-right: 19px;
}
#avgTable th,
#avgTable td {
  border: 1px solid #c8ced3 !important;
  text-align: left;
  font-size: 14px;
}
.mycols:first-child {
  padding-right: 2px !important;
}
.mycols:last-child {
  padding-left: 2px;
}
.mycols:not(:first-child):not(:last-child) {
  padding-left: 2px;
  padding-right: 2px;
}
.minWid {
  min-width: 250px;
}
</style>
